import React from 'react';
import { JourneyStrip } from './JourneyStrip';
import { MAIN_MOCKUP, MOCKUP_ALT, REVEAL_SUB, REVEAL_TITLE } from '../data/sushiContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="reveal-title" data-id="element-260" data-mp="1l0krk1tzgdto">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-261" data-mp="1pxkwg9f3jaj7">
        <h2 id="reveal-title" className="font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-262" data-mp="1b9q4wwctrc7p">
          {REVEAL_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-snug text-body sm:text-[16px]" data-id="element-263" data-mp="12acsbutem7ir">
          {REVEAL_SUB}
        </p>

        <div className="mt-6 border-y border-charcoal-600 py-4" data-id="element-264" data-mp="179667ocls0jg">
          <JourneyStrip data-id="element-265" data-mp="sb41vbxqzb15" />
        </div>

        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto mt-8 w-full max-w-xl sm:max-w-3xl" width={1536} height={1024} data-id="element-266" data-mp="sc5psgzv3s0a" />
      </div>
    </section>;
}